
<!-- Mobile View -->

<div class="minimal-item-container d-blok d-md-none" *ngIf="booking">
  <div class="container" [ngClass]="{ unavailable: unavailable }">
    <div class="row">
      <div class="col-3 image-container">
        <img src="{{ type?.PictureUri }}" />
        <div class="price">
          <span *ngIf="unavailable"><mat-icon>cancel</mat-icon><br />Finns ej</span>
          <ng-container *ngIf="!unavailable">
            <div *ngIf="booking.Type == 3"><mat-icon>person</mat-icon></div>
            <div *ngIf="booking.Type == 0"><mat-icon style="color: var(--yellow)">star</mat-icon></div>
            <div *ngIf="booking.Type != 0 && booking.Type != 3"><mat-icon>alt_route</mat-icon></div>
          </ng-container>
        </div>
      </div>
      <div class="col-9">
        <div>
          <div class="propertyRow">
            <div class="booking-option-title" [ngClass]="{ changed: booking.HasObjectTypeChanged,  unchanged: !booking.HasObjectTypeChanged }">{{ type?.Alias }}</div>

            <div class="booking-option-distance">
              <b>Hämtas: </b><br />
              <span *ngIf="pickupLocation" [ngClass]="{ changed: booking.HasPickupLocationChanged,  unchanged: !booking.HasPickupLocationChanged }">{{pickupLocation.Name}}</span><br /><span [ngClass]="{ changed: booking.HasPickupTimeChanged,  unchanged: !booking.HasPickupTimeChanged }">{{booking.PickupTime | date : 'dd MMM HH:mm' | transliterate}}</span>
            </div>
            <div class="booking-option-distance">
              <b>Återlämnas: </b><br />
              <span *ngIf="returnLocation" [ngClass]="{ changed: booking.HasReturnLocationChanged,  unchanged: !booking.HasReturnLocationChanged }">{{returnLocation.Name}}</span><br /><span [ngClass]="{ changed: booking.HasReturnTimeChanged,  unchanged: !booking.HasReturnTimeChanged }">{{booking.ReturnTime | date : 'dd MMM HH:mm' | transliterate}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" style="text-align: center;">

        <ng-container *ngIf="!unavailable">
          <div *ngIf="booking.IsPreliminary && booking.PredictedBindDate">Beräknad ankomst: {{ booking.PredictedBindDate | date: 'dd/MM HH:mm' | transliterate }}</div>
          <button mat-raised-button *ngIf="booking.IsPreliminary" (click)="select()">{{'Intellitrailer.OW.BookingOption.btnPreBook' | translate: 'Preliminary book'}} {{ booking.Price?.DiscountedTotalPrice | currency | transliterate }}</button>
          <button mat-raised-button *ngIf="!booking.IsPreliminary" (click)="select()"> {{'Intellitrailer.OW.BookingOption.btnBook' | translate: 'Book'}} {{ booking.Price?.DiscountedTotalPrice | currency | transliterate }}</button>
        </ng-container>


      </div>
    </div>
  </div>
</div>

<!-- Web View -->

<div class="d-none d-md-block" style="margin: 0 auto">
  <div class="container my-auto"  [ngClass]="{ unavailable: unavailable }">
    <div class="image-container">
      <div class="item-image" style="height: 100px; background-image: url({{ type?.PictureUri }});"></div>
    </div>
    <div class="title-with-divider">
      <div class="title" [ngClass]="{ changed: booking.HasObjectTypeChanged,  unchanged: !booking.HasObjectTypeChanged }">{{type?.Alias}}</div>
    </div>

    <div>
      <div class="propertyRow">
        <div class="booking-option">
          <div class="row">
            <div class="col-5">
              <b>Hämtas: </b><br />
            </div>
            <div class="col-7">
              <span *ngIf="pickupLocation" [ngClass]="{ changed: booking.HasPickupLocationChanged,  unchanged: !booking.HasPickupLocationChanged }">{{pickupLocation.Name}}</span><br /><span [ngClass]="{ changed: booking.HasPickupTimeChanged,  unchanged: !booking.HasPickupTimeChanged }">{{booking.PickupTime | date : 'dd MMM HH:mm'}}</span>
            </div>
          </div>
        </div>
        <div class="booking-option-distance">
          <div class="row">
            <div class="col-5">
              <b>Återlämnas: </b><br />
            </div>
            <div class="col-7">
              <span *ngIf="returnLocation" [ngClass]="{ changed: booking.HasReturnLocationChanged,  unchanged: !booking.HasReturnLocationChanged }">{{returnLocation.Name}}</span><br /><span [ngClass]="{ changed: booking.HasReturnTimeChanged,  unchanged: !booking.HasReturnTimeChanged }">{{booking.ReturnTime | date : 'dd MMM HH:mm'}}</span>
            </div>
          </div>
          </div>
        </div>

    <div class="title-with-divider">
      <div class="title">
        {{ booking.Price?.DiscountedTotalPrice | currency | transliterate }}
      </div>
    </div>
    <div class="row">
      <button [disabled]="unavailable" type="button" class="col-12" style="min-width: 100px; margin: 0 auto" mat-raised-button (click)="select()">
        @if(unavailable){
        <strong>
          {{ 'tIntellitrailer.Booking.Components.BookingOption.btnUnavailable' | translate : 'Unavailable'}}
        </strong>
        }
        @else{
        <strong>
          {{ 'tIntellitrailer.Booking.Components.BookingOption.Select' | translate : 'Select'}}
        </strong>
        }

      </button>
    </div>
  </div>
</div>
